/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Segment} from './Segment';

export interface DocumentMenu {
  id: number;
  header: string;
  icon?: string;
  parent?: DocumentMenu;
  parentId?: number;
  enabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  children?: DocumentMenu[];
  segments?: Segment[] | number[];
  pos?: number;
}
